<template>
  <div id="app">
    <AppLoading :show="!profile_loaded"></AppLoading>
    <localization></localization>
  </div>
</template>

<script>
import AppLoading from '@/components/widgets/AppLoading'
import { mapGetters, mapMutations } from 'vuex'
import { getInstance } from '@/plugins/auth'
import Localization from '@/localization'
import axios from 'axios'
import configApp from './services/config'

export default {
  name: 'app',
  components: { Localization, AppLoading },
  computed: {
    ...mapGetters(['user', 'token', 'profile_loaded']),
    nextRoute() {
      return this.$route.query.redirect || '/'
    },
  },
  methods: {
    ...mapMutations(['SET_TOKEN','updateCompletedSignup','setProfileLoaded', 'UPDATE_LOADING_STATE']),
    setLoadingState(state){
      this.UPDATE_LOADING_STATE({ active: state });
    },
  },
  watch: {
    user(auth) {
      if (auth) {
        this.$router.replace(this.nextRoute)
      }
    },
    '$route'(to) {
      const query = Object.assign({}, to.query)
      this.$store.commit('SETUP_URL_SETTINGS', query)
    },
  },
  async mounted() {
    const authService = getInstance()
    authService.$watch('loading', async (loading) => {
      if (loading === false) {
        if (this.token === null) {
          
          const token = await this.$auth.getTokenSilently()
          this.SET_TOKEN(token);

          if(!this.profile_loaded){

            try {

              let userResponse = {};
              try {
                userResponse = await axios.get(`${configApp.apiURL}/api/user/profile`, { headers: { Authorization: `Bearer ${this.token}` }});
              } catch (error) {
                console.log('Tell me something');
              }

              this.setLoadingState(false);
              
              if(userResponse.data) {
                const userProfile = userResponse.data;
                this.updateCompletedSignup(userProfile.completed_signup);
                this.setProfileLoaded(true);
              }else{
                this.setProfileLoaded(true);
              } 
              
            } catch (error) {
              console.log('Error loading profile');
            }

          }else{
            console.log('PROFILE WAS LOADED... NOT CALLING PROFILE');
          }
        }
      }
    })
  },
}
</script>

<style lang="scss">
@import "vue-select/src/scss/vue-select.scss";
</style>

<style>
.kiwi-button-simple{
  outline: none;
  width: auto;
  font-size: 18px;
  border: 1px solid gray;
  padding: 10px 30px 10px 30px ;
  border-radius: 3px;
}
.kiwi-button{
  outline: none;
  width: auto;
  font-size: 18px;
  background: linear-gradient(180deg,#6371c7,#5563c1);
  color: white;
  padding: 10px 30px 10px 30px ;
  border-radius: 3px;
  border: 1px solid #5c6ac4;
}
.kiwi-button:hover {
  background: linear-gradient(180deg,#6371c7,#4856b3);
}
.kiwi-button:focus {
  outline:0;
}
</style>
